module.exports = __webpack_public_path__ + "images/9dc5975460060e14e51757da74e817e7.svg";